import styled from 'styled-components';
import OutsideClickHandler from 'react-outside-click-handler';

import { FlowContextMenu } from 'types';

const Container = styled.div`
  position: fixed;
  width: 200px;
  background-color: ${(props) => props.theme.ui.menu.bgColor};
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border: 1px solid ${(props) => props.theme.global.borderColor};
  padding: 6px 0;
  z-index: 9999999;
`;

const Tab = styled.div`
  padding: 4px 20px;
  font-size: 13px;
  &:hover {
    ${({ theme: { global } }) => ({
      backgroundColor: global.mainColor,
      color: global.whiteTextColor,
    })}
  }
`;

interface ContextMenuProps extends FlowContextMenu {
  onClose: () => void;
}

const ContextMenu = ({
  pos,
  onDelete,
  onGrouping,
  onUnGroup,
  // onCut,
  onCopy,
  onPaste,
  onClose,
  onSourceNode,
  onUnSourceNode,
  onTargetNode,
  onUnTargetNode,
}: ContextMenuProps) => {
  const handleTabClick = (action: () => void) => {
    action();
    onClose();
  };

  return (
    <OutsideClickHandler onOutsideClick={onClose}>
      <Container style={{ top: `${pos.y}px`, left: `${pos.x}px` }}>
        {onDelete && <Tab onClick={() => handleTabClick(onDelete)}>삭제하기</Tab>}
        {onCopy && <Tab onClick={() => handleTabClick(onCopy)}>복사하기</Tab>}
        {/* {onCut && <Tab onClick={() => handleTabClick(onCut)}>잘라내기</Tab>} */}
        {onPaste && <Tab onClick={() => handleTabClick(onPaste)}>붙여넣기</Tab>}
        {onGrouping && <Tab onClick={() => handleTabClick(onGrouping)}>그룹 블록 만들기</Tab>}
        {onUnGroup && <Tab onClick={() => handleTabClick(onUnGroup)}>그룹 해제</Tab>}
        {onTargetNode && <Tab onClick={() => handleTabClick(onTargetNode)}>In 블록 설정</Tab>}
        {onUnTargetNode && <Tab onClick={() => handleTabClick(onUnTargetNode)}>In 블록 해제</Tab>}
        {onSourceNode && <Tab onClick={() => handleTabClick(onSourceNode)}>Out 블록 설정</Tab>}
        {onUnSourceNode && <Tab onClick={() => handleTabClick(onUnSourceNode)}>Out 블록 해제</Tab>}
      </Container>
    </OutsideClickHandler>
  );
};

export default ContextMenu;
